import React, { useContext } from 'react';
import {
  DropdownFilter,
  InputDropdown,
} from 'src/components/dropdown-filter/DropdownFilter';
import { useTranslation } from 'react-i18next';
import { ItemFilter } from 'src/components/dropdown-filter/filter';
import { CheckboxList } from 'src/components/dropdown-filter/CheckboxList';
import { ListContext } from '../context';

export const FilterApi = () => {
  const { dispatch, filters } = useContext(ListContext);

  const { t } = useTranslation();

  const items = [
    'acquiring/process',
    'acquiring/capture',
    'acquiring/refund',
    'acquiring/void',
    'acquiring/reverse',
  ].map((item) => ({
    value: item,
    label: item,
  }));

  const itemToggle = (options: { checked: boolean; item: ItemFilter }) =>
    dispatch({
      type: options.checked ? 'ADD_API_FILTER' : 'REMOVE_API_FILTER',
      itemFilter: options.item,
    });

  const clearFilter = () => dispatch({ type: 'RESET_API_FILTER' });

  return (
    <DropdownFilter
      title={t('logs.api.filters.api')}
      headerSecondaryLabel={t(
        'transactionsManagement.transactions.list.filters.numberSelected',
        { totalItems: filters.api.length }
      )}
      onClearFilter={clearFilter}
      trigger={(dropdownProps) => (
        <InputDropdown
          disabled
          name="filterMatchTypes"
          label={t('logs.api.filters.api')}
          placeholder={t(
            'transactionsManagement.transactions.list.filters.all'
          )}
          value={
            filters.api.length
              ? t(
                  'transactionsManagement.transactions.list.filters.numberSelected',
                  { totalItems: filters.api.length }
                )
              : ''
          }
          {...dropdownProps}
        />
      )}
    >
      <CheckboxList
        items={items}
        filters={filters.api}
        onItemToggle={itemToggle}
        totalItems={filters.api.length}
        heightClassName="h-auto"
      />
    </DropdownFilter>
  );
};
